<script>
  import { mapGetters, mapActions } from 'vuex'
  import * as Helper from '@/modules/helper/index'
  import DeviceInfo from '@/modules/util/deviceInfo'
  export default {
    props: {
      Parent: {
        type: Object,
        default: {}
      },
      SubscriptionModuleId: {
        type: [String, Number],
        default: 0
      },
      images: {
        type: Array,
        default() {
          return []
        }
      },
      albumId: {
        type: String,
        default: ''
      },
      albumName: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        likeControl: null,
        likeIconControl: null,
        imageDetails: null,
        favoritesControl: null,
        favoritesIconControl: null,
        shareControl: null,
        IsFavorite: false,
        dataRef: ''
      }
    },
    computed: {
      ...mapGetters([
        'AppConfig',
        'ImageGalleries',
        'resource'
      ]),
      AllowLikes() {
        return Helper.convertBoolean(this.Parent.AllowLikes)
      },
      AllowFavorite() {
        return false
      },
      AllowSharing() {
        return Helper.convertBoolean(this.Parent.AllowSharing)
      },
      photos() {
        let photoArray = []
        let contentAssetsBaseUrl = this.AppConfig.Urls.ContentAssetsBaseUrl
        let $this = this
        this.images.forEach(function(image) {
          if (!Helper.convertBoolean(image.RowDeleted)) {
            let likeCaption = ''
            if ($this.AllowLikes) {
              likeCaption = '<div class="img-like"><a> <span id="noOfLike_' + image.Id + '">' + image.Likes + '</span><span class="icon-dislike-them-color"></span></a></div>'
            }
            photoArray.push({
              url: contentAssetsBaseUrl + image.Image,
              caption: likeCaption + '<div class="img-description">' + image.Description + '</div>',
              IsLiked: Helper.convertBoolean(image.IsLiked),
              Likes: image.Likes,
              Id: image.Id,
              imageName: image.Image
            })
          }
        })
        return photoArray
      },
      getNavStyle() {
        if (Helper.IsValid(this.AppConfig.DesignSettings.TitleBarOpacity)) {
          let hashCode = Helper.HashCodeFromInt(this.AppConfig.DesignSettings.AppThemeColor)
          let colorrgb = Helper.hexToRgb(hashCode)
          return `style="z-index: 7000;color: ${Helper.HashCodeFromInt(this.AppConfig.DesignSettings.TitleBarFontColor)};background:rgba(${colorrgb},${this.AppConfig.DesignSettings.TitleBarOpacity})"`
        }
      },
      ActiveIndex () {
        return this.dataRef.activeIndex
      },
    },
    watch: {
      images: {
        deep: true,
        handler(value, oldValue) {
          if (this.$f7route.query.index && value.length > 0) {
            this.openPhotoBrowser(parseInt(this.$f7route.query.index))
          }
        }
      }
    },
    created () {
      window.addEventListener('click', this.handleFabBtnClose)
    },
    mounted() {
      if (this.$f7route.query.index && this.images.length > 0) {
        this.openPhotoBrowser(parseInt(this.$f7route.query.index))
      }
    },
    beforeDestroy() {
      window.removeEventListener('click', this.handleFabBtnClose)
    },
    methods: {
      ...mapActions([
        'addUpdateLike',
        'shareInformation',
        'addMyFavorite'
      ]),
      toolbarTemplate() {
        let toolbarHtml = `
          <div class="toolbar tabbar toolbar-bottom-md tabbar-ios">
            <div class="toolbar-inner">
              <a href="#" class="link photo-browser-prev">
                <i class="icon icon-back"></i>
              </a>
              <a href="#" class="link photo-browser-next">
                <i class="icon icon-forward "></i>
              </a>
            </div>
          </div>
          ${(this.AllowLikes || this.AllowFavorite || this.AllowSharing) ? `
            <div class="fab fab-right-bottom" id="speedDial">
              <a href="#" class="floating_btn_class">
                <i class="icon f7-icons floating_btn_class">add</i>
                <i class="icon f7-icons floating_btn_class">close</i>
              </a>
              <div class="fab-buttons fab-buttons-top">
                ${this.AllowLikes ? '<a href="#" id="like" ><span class="custom-icon icon-like"></span></a>' : ''}
                ${this.AllowFavorite ? '<a href="#" id="favorites"><span class="custom-icon icon-favorites-add"></span> </a>' : ''}
                ${this.AllowSharing ? '<a href="#" id="share"> <span class="custom-icon icon-share" ></span> </a>' : ''}
              </div>
            </div>
            ` : ''
          }
        `.trim();
        // let template = ''
        // if (this.AllowLikes || this.AllowFavorite || this.AllowSharing) {
        //   template = ''
        //   if (this.AllowLikes) {
        //     template = template + '<a href="#" id="like" ><span class="custom-icon icon-like"></span></a>'
        //   }
        //   if (this.AllowFavorite) {
        //     template = template + '<a href="#" id="favorites"><span class="custom-icon icon-favorites-add"></span></a>'
        //   }
        //   if (this.AllowSharing) {
        //     template = template + '<a href="#" id="share"><span class="custom-icon icon-share" ></span></a>'
        //   }
        //   template = template + '</div></div><div class="toolbar custontoolbar tabbar">    <div class="toolbar-inner">  <a href="#" class="link photo-browser-prev"> <i class="icon icon-prev {{iconsColorClass}}"></i> </a> <a href="#" class="link photo-browser-next"> <i class="icon icon-next {{iconsColorClass}}"></i> </a> </div></div>'
        // }
        return toolbarHtml
      },
      navbarTemplate() {
        let backLinkText = this.resource.closeBtn
        let isPopup = true
        let navbarHtml = `
          <div class="navbar" ${this.getNavStyle}>
            <div class="navbar-inner sliding">
              <div class="left">
                <a href="#" class="link ${isPopup ? 'popup-close' : ''} ${!backLinkText ? 'icon-only' : ''} ${!isPopup ? 'back' : ''}" ${isPopup ? 'data-popup=".photo-browser-popup"' : ''}>
                  <i class="icon icon-back"></i>
                  ${(backLinkText && this.$theme.ios) ? `<span>${backLinkText}</span>` : ''}
                </a>
              </div>
              <div class="title">
                <span class="photo-browser-current"></span>
                <span class="photo-browser-of">${this.resource.ofText}</span>
                <span class="photo-browser-total"></span>
              </div>
              <div class="right"></div>
            </div>
          </div>
        `.trim()
        return navbarHtml
      },
      openPhotoBrowser: function(index) {
        const pb = this.$f7.photoBrowser.create({
          renderNavbar: this.navbarTemplate,
          renderToolbar: this.toolbarTemplate,
          navbarOfText: this.resource.ofText,
          photos: this.photos,
          expositionHideCaptions: true,
          routableModals: false,
          // onClose: this.onClose,
          // onOpen: this.onOpen,
          // onSlideChangeEnd: this.onSlideChangeEnd,
          // swiper: {
          //   on: {
          //     slideChangeTransitionStart: this.onSlideChangeStart
          //   }
          // }
        })
        pb.open(index)
        this.dataRef = pb
        this.imageDetails = this.photos[index]
        if (pb) {
          let swiper = pb.swiper
          swiper.on('slideChange', this.onSlideChangeStart)
        }
        if (this.AllowLikes) {
          this.likeControl = document.getElementById('like')
          this.likeControl.addEventListener('click', this.onLikeClick)
          this.likeIconControl = this.likeControl.getElementsByTagName('span')[0]
          if (Helper.convertBoolean(this.imageDetails.IsLiked)) {
            this.likeIconControl.classList.remove('icon-like')
            this.likeIconControl.classList.add('icon-dislike')
          } else {
            this.likeIconControl.classList.remove('icon-dislike')
            this.likeIconControl.classList.add('icon-like')
          }
        }
        if (this.AllowFavorite) {
          this.favoritesControl = document.getElementById('favorites')
          this.favoritesControl.addEventListener('click', this.onFavoriteClick)
          this.favoritesIconControl = this.favoritesControl.getElementsByTagName('span')[0]

          this.IsFavorite = Helper.CheckIsFavorite(this.imageDetails.Id, this.albumId)
          if (this.IsFavorite) {
            this.favoritesIconControl.classList.remove('icon-favorites-add')
            this.favoritesIconControl.classList.add('icon-favorites-remove')
          } else {
            this.favoritesIconControl.classList.remove('icon-favorites-remove')
            this.favoritesIconControl.classList.add('icon-favorites-add')
          }
        }
        if (this.AllowSharing) {
          this.shareControl = document.getElementById('share')
          this.shareControl.addEventListener('click', this.onShareCLick)
        }

        if (this.AllowLikes || this.AllowFavorite || this.AllowSharing) {
          let speedDial = document.getElementById('speedDial')
          if (this.$theme.md) {
            speedDial.classList.add('tabbar-fixed-speed-dial-material')
          }
        }
      },
      onSlideChangeStart: function() {
        this.$f7.fab.close()
        let swiper = this.dataRef
        if (this.AllowLikes || this.AllowFavorite || this.AllowSharing) {
          let speedDial = document.getElementById('speedDial')
          this.$f7.fab.close(speedDial)
        }
        this.imageDetails = this.photos[swiper.activeIndex]
        // this.ActiveIndex = swiper.activeIndex
        if (this.AllowLikes) {
          this.likeControl = document.getElementById('like')
          this.likeIconControl = this.likeControl.getElementsByTagName('span')[0]
          // this.imageDetails = this.photos[swiper.activeIndex]
          if (Helper.convertBoolean(this.imageDetails.IsLiked)) {
            this.likeIconControl.classList.remove('icon-like')
            this.likeIconControl.classList.add('icon-dislike')
          } else {
            this.likeIconControl.classList.remove('icon-dislike')
            this.likeIconControl.classList.add('icon-like')
          }
        }
        // Favorite
        if (this.AllowFavorite) {
          this.favoritesControl = document.getElementById('favorites')
          this.favoritesIconControl = this.favoritesControl.getElementsByTagName('span')[0]
          // this.imageDetails = this.photos[swiper.activeIndex]
          this.IsFavorite = Helper.CheckIsFavorite(this.imageDetails.Id, this.albumId)
          if (this.IsFavorite) {
            this.favoritesIconControl.classList.remove('iicon-favorites-add')
            this.favoritesIconControl.classList.add('icon-favorites-remove')
          } else {
            this.favoritesIconControl.classList.remove('icon-favorites-remove')
            this.favoritesIconControl.classList.add('icon-favorites-add')
          }
        }
      },
      onLikeClick() {
        // let speedDial = document.getElementById('speedDial')
        // if (speedDial) {
          this.$f7.fab.close()
        // } 
        if (Helper.IsUserActionAllow()) {
          this.likeIconControl = this.likeControl.getElementsByTagName('span')[0]
          if (Helper.convertBoolean(this.imageDetails.IsLiked)) {
            this.likeIconControl.classList.remove('icon-dislike')
            this.likeIconControl.classList.add('icon-like')
          } else {
            this.likeIconControl.classList.remove('icon-like')
            this.likeIconControl.classList.add('icon-dislike')
          }
          // if (this.AllowLikes || this.AllowFavorite || this.AllowSharing) {
          //   let speedDial = document.getElementById('speedDial')
          //   this.$f7.fab.close(speedDial)
          // }
          let noOfLikeControl = document.getElementById('noOfLike_' + this.imageDetails.Id)
          this.imageDetails.Likes = !Helper.convertBoolean(this.imageDetails.IsLiked) ? this.imageDetails.Likes + 1 : this.imageDetails.Likes - 1
          noOfLikeControl.innerHTML = this.imageDetails.Likes
          let Like = {
            Album_Id: this.albumId,
            Reference_Id: this.imageDetails.Id,
            Liked: !Helper.convertBoolean(this.imageDetails.IsLiked),
            AppGUID: this.AppConfig.AppGUID,
            ContentType: 2,
            NotificationContent: {
              Title: this.albumName,
              ImageName: this.imageDetails.imageName,
              Comment: '',
              Navigationurl: '/image-album-view/' + this.SubscriptionModuleId + '/' + this.albumId + '?index=' + this.ActiveIndex
            }
          }
          this.addUpdateLike(Like).then(() => {
            this.$f7.notification.create({
              title: Helper.convertBoolean(this.imageDetails.IsLiked) ? this.resource.likeSuccesTitle : this.resource.disLikeSuccesTitle, // apply only ios theme
              subtitle: Helper.convertBoolean(this.imageDetails.IsLiked) ? this.resource.likeSuccesMessage : this.resource.disLikeSuccesMessage,
              cssClass: 'success-notification',
              closeOnClick: true,
              closeTimeout: 3000
            }).open()
          })
          this.imageDetails.IsLiked = !Helper.convertBoolean(this.imageDetails.IsLiked)
        } else {
          let modalOptions = {
            title: this.resource.warningTitle,
            text: this.resource.warningMessage,
            buttonText: this.resource.closeBtn,
            downloadbuttonText: DeviceInfo.isAndroid ? this.resource.AndroidDownload : this.resource.AppleDownload,
            $f7: this.$f7
          }
          this.$showModal(modalOptions)
        }
      },
      onFavoriteClick() {
        this.$f7.fab.close()
        if (Helper.IsUserActionAllow()) {
          this.favoritesIconControl = this.favoritesControl.getElementsByTagName('span')[0]
          this.IsFavorite = Helper.CheckIsFavorite(this.imageDetails.Id, this.albumId)
          if (this.IsFavorite) {
            this.favoritesIconControl.classList.remove('icon-favorites-remove')
            this.favoritesIconControl.classList.add('icon-favorites-add')
          } else {
            this.favoritesIconControl.classList.remove('icon-favorites-add')
            this.favoritesIconControl.classList.add('icon-favorites-remove')
          }
          // if (this.AllowLikes || this.AllowFavorite || this.AllowSharing) {
          //   let speedDial = document.getElementById('speedDial')
          //   this.$f7.fab.close(speedDial)
          // }
          let favData = {
            Reference_Id: this.imageDetails.Id,
            ReferenceParent_Id: this.albumId
          }
          this.addMyFavorite(favData)
          this.IsFavorite = !Helper.convertBoolean(this.IsFavorite)
        } else {
          // this.$f7.addNotification({
          //   title: this.resource.warningTitle, // apply only ios theme
          //   message: this.resource.warningMessage,
          //   hold: 3000,
          //   closeIcon: false,
          //   button: {
          //     text: this.resource.closeBtn
          //   },
          //   additionalClass: 'error-notification' // apply only ios theme
          // })
          let modalOptions = {
            title: this.resource.warningTitle,
            text: this.resource.warningMessage,
            buttonText: this.resource.closeBtn,
            downloadbuttonText: DeviceInfo.isAndroid ? this.resource.AndroidDownload : this.resource.AppleDownload,
            $f7: this.$f7
          }
          this.$showModal(modalOptions)
        }
      },
      onShareCLick() {
        this.$f7.fab.close()
        if (Helper.IsUserActionAllow()) {
          // if (this.AllowLikes || this.AllowFavorite || this.AllowSharing) {
          //   let speedDial = document.getElementById('speedDial')
          //   this.$f7.fab.close(speedDial)
          // }
          let Options = {
            appConfig: this.AppConfig,
            moduleId: this.ImageGalleries.Parent.Module_Id,
            subscriptionModuleId: this.ImageGalleries.Parent.SubscriptionModule_Id,
            shareId: this.albumId,
            path: Helper.CurrentlocationURL(),
            orderId: this.ActiveIndex
          }
          // console.log(Options)
          this.shareInformation(Options)
        } else {
          // this.$f7.addNotification({
          //   title: this.resource.warningTitle, // apply only ios theme
          //   message: this.resource.warningMessage,
          //   hold: 3000,
          //   closeIcon: false,
          //   button: {
          //     text: this.resource.closeBtn
          //   },
          //   additionalClass: 'error-notification' // apply only ios theme
          // })
          let modalOptions = {
            title: this.resource.warningTitle,
            text: this.resource.warningMessage,
            buttonText: this.resource.closeBtn,
            downloadbuttonText: DeviceInfo.isAndroid ? this.resource.AndroidDownload : this.resource.AppleDownload,
            $f7: this.$f7
          }
          this.$showModal(modalOptions)
        }
      },
      getStyle: function(url) {
        return {
          'background-image': 'url(' + url + ')'
        }
      },
      handleFabBtnClose (event) {
        if (event.srcElement.className.indexOf('floating_btn_class') < 0 && speedDial) {
          this.$f7.fab.close()
        }
      }
    }
  }

</script>
<template>
  <f7-page-content>
    <f7-row no-gap class="image-wrapper" v-if="images">
      <f7-photo-browser :class="{'ios-photo-browser': $theme.ios}" ref="pb" :init="false">
      </f7-photo-browser>
      <f7-col v-for="(Image, index) in photos" width="33" tablet-width="20" :key="index" class="image-box">
        <f7-link @click="openPhotoBrowser(index)" :id="Image.Image_Id">
          <div :style="getStyle(Image.url)" class="image-box-bg">
          </div>
        </f7-link>
      </f7-col>
    </f7-row>
  </f7-page-content>
</template>
<style>
.image-box {
    border: 1px solid rgba(255, 255, 255, 0.70);
    position: relative;
}
.image-box a .image-box-bg {
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    padding-bottom: 100% !important;
}
.image-wrapper {
    justify-content: flex-start!important;
}
.img-like {
    text-align: left;
    color: #007DFB;
    margin-top: -45px;
    margin-left: 12px;
}
.img-like .icon-dislike-them-color {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-left: 5px;
    margin-right: 5px;
}
.img-description {
    text-align: left;
    padding-right: 60px;
}
.photo-browser-exposed .img-description {
    padding-right: 0px;
}
/* .tabbar-fixed-speed-dial-material {
  bottom: 59px!important;
} */

.toolbar-bottom-md[class]{
      box-shadow: none!important;
    }
.ios.device-pixel-ratio-3 .toolbar:before{
  display:none;
}
.md .toolbar-bottom-md:after, .md .messagebar:after{
   display:none;
}
/*.layout-onAirDefault .toolbar:before, .toolbar.layout-onAirDefault:before{
  display:none;
}*/
</style>




// WEBPACK FOOTER //
// src/components/image-gallery/ImageBrowser.vue